import browser from '../../../../browser';

import lockSvg from '../images/lock.svg';

function getSignInLinkTitleFromUserLocale() {
  const url = window.location.href;
  return url.includes('/fr/')
    ? 'Connectez-vous pour accéder au contenu vidéo.'
    : 'Sign-in to access our video content.';
}

function init(containerToLock, insertionNode, redirectionLink = '') {
  const sandboxIframeWrapper = containerToLock;

  sandboxIframeWrapper.style.filter = 'blur(4px)';

  const lockIcon = browser.document.createElement('img');
  lockIcon.classList.add('oc-locked-content__lock-icon');
  lockIcon.src = lockSvg;
  lockIcon.alt = '';

  if (redirectionLink) {
    const loginLinkWrapper = browser.document.createElement('a');
    loginLinkWrapper.classList.add('oc-locked-content');
    loginLinkWrapper.href = redirectionLink;
    loginLinkWrapper.appendChild(sandboxIframeWrapper);
    loginLinkWrapper.title = getSignInLinkTitleFromUserLocale();

    sandboxIframeWrapper.style.pointerEvents = 'none';
    loginLinkWrapper.appendChild(lockIcon);

    insertionNode.parentNode.insertBefore(loginLinkWrapper, insertionNode);
  } else {
    const lockWrapper = browser.document.createElement('div');
    lockWrapper.classList.add('oc-locked-content');
    lockWrapper.appendChild(sandboxIframeWrapper);

    sandboxIframeWrapper.style.pointerEvents = 'none';
    lockWrapper.appendChild(lockIcon);

    insertionNode.parentNode.insertBefore(lockWrapper, insertionNode);
  }
}

export default {
  init,
};
